import React, { useState } from 'react';
import axios from 'axios';

const DoctorSignup = () => {
  const [form, setForm] = useState({ name: '', email: '', specialization: '', password: '' });
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setMessage('');
    setError('');
    try {
      const res = await axios.post('https://ricgop.online/api/doctor_signup.php', form);
      if (res.data.status === 'success') {
        setMessage('Signup successful. You can now login.');
        setForm({ name: '', email: '', specialization: '', password: '' });
      } else {
        setError(res.data.message);
      }
    } catch {
      setError('Signup failed. Please try again later.');
    }
  };

  return (
    <>
      <div className="signup-container">
        <div className="background-shapes">
          <span className="shape shape1"></span>
          <span className="shape shape2"></span>
          <span className="shape shape3"></span>
        </div>

        <div className="signup-card">
          <h2 className="signup-title">Doctor Sign Up</h2>

          {message && <p className="message success">{message}</p>}
          {error && <p className="message error">{error}</p>}

          <form className="signup-form" onSubmit={handleSubmit} noValidate>
            <label>
              Full Name
              <input
                name="name"
                placeholder="Enter your full name"
                value={form.name}
                onChange={handleChange}
                required
                autoComplete="name"
              />
            </label>

            <label>
              Email
              <input
                type="email"
                name="email"
                placeholder="Enter your email"
                value={form.email}
                onChange={handleChange}
                required
                autoComplete="email"
              />
            </label>

            <label>
              Specialization
              <input
                name="specialization"
                placeholder="Your specialization (optional)"
                value={form.specialization}
                onChange={handleChange}
                autoComplete="off"
              />
            </label>

            <label>
              Password
              <input
                type="password"
                name="password"
                placeholder="Choose a secure password"
                value={form.password}
                onChange={handleChange}
                required
                autoComplete="new-password"
              />
            </label>

            <div className="btn-group">
              <button type="submit" className="signup-btn">
                Sign Up
              </button>
              <button
                type="button"
                className="signup-btn secondary"
                onClick={() => (window.location.href = '/doctor/login')}
              >
                Sign In
              </button>
            </div>
          </form>
        </div>
      </div>

      <style>{`
        /* Reset & base */
        * {
          box-sizing: border-box;
        }
        body, html, #root {
          height: 100%;
          margin: 0;
          font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
          background: #0f2027;  /* fallback */
          background: linear-gradient(135deg, #2c5364, #203a43, #0f2027);
          overflow: hidden;
          color: #f0f0f0;
        }

        .signup-container {
          position: relative;
          display: flex;
          justify-content: center;
          align-items: center;
          height: 100vh;
          padding: 20px;
          z-index: 1;
        }

        .background-shapes {
          position: absolute;
          top: 0; left: 0; right: 0; bottom: 0;
          overflow: hidden;
          z-index: 0;
        }
        .background-shapes .shape {
          position: absolute;
          border-radius: 50%;
          opacity: 0.3;
          filter: blur(100px);
          animation: float 20s infinite ease-in-out;
        }
        .shape1 {
          width: 300px;
          height: 300px;
          background: #ff0057;
          top: 10%;
          left: 5%;
          animation-delay: 0s;
        }
        .shape2 {
          width: 350px;
          height: 350px;
          background: #ff4b87;
          top: 50%;
          right: 10%;
          animation-delay: 5s;
        }
        .shape3 {
          width: 200px;
          height: 200px;
          background: #8e44ad;
          bottom: 15%;
          left: 40%;
          animation-delay: 10s;
        }
        @keyframes float {
          0%, 100% { transform: translateY(0) translateX(0); }
          50% { transform: translateY(-30px) translateX(20px); }
        }

        .signup-card {
          position: relative;
          background: rgba(255, 255, 255, 0.1);
          backdrop-filter: blur(15px);
          border-radius: 20px;
          box-shadow: 0 8px 32px rgba(0,0,0,0.25);
          padding: 45px 40px 55px;
          width: 100%;
          max-width: 420px;
          z-index: 2;
          color: #fff;
          transition: box-shadow 0.3s ease;
        }
        .signup-card:hover {
          box-shadow: 0 12px 40px rgba(255, 75, 135, 0.6);
        }

        .signup-title {
          text-align: center;
          margin-bottom: 32px;
          font-weight: 800;
          font-size: 2rem;
          letter-spacing: 1.5px;
          text-shadow: 0 0 10px rgba(255, 75, 135, 0.8);
        }

        .message {
          font-size: 1rem;
          padding: 14px 18px;
          border-radius: 10px;
          margin-bottom: 25px;
          text-align: center;
          user-select: none;
          font-weight: 700;
          box-shadow: 0 2px 8px rgba(0,0,0,0.2);
        }
        .message.success {
          background-color: rgba(72, 187, 120, 0.8);
          color: #e6f4ea;
          border: 1px solid #48bb78;
          text-shadow: 0 0 6px #48bb78;
        }
        .message.error {
          background-color: rgba(255, 99, 132, 0.85);
          color: #f9d6db;
          border: 1px solid #ff6384;
          text-shadow: 0 0 6px #ff6384;
        }

        .signup-form label {
          display: block;
          margin-bottom: 22px;
          font-weight: 700;
          font-size: 1.05rem;
          letter-spacing: 0.02em;
          color: #fff;
          text-shadow: 0 0 6px rgba(0,0,0,0.2);
        }

        .signup-form input {
          width: 100%;
          padding: 14px 18px;
          font-size: 1.1rem;
          border-radius: 12px;
          border: 1.5px solid rgba(255,255,255,0.4);
          background: rgba(255,255,255,0.1);
          color: #fff;
          font-family: inherit;
          margin-top: 8px;
          outline-offset: 3px;
          transition: border-color 0.3s ease, box-shadow 0.3s ease, background 0.3s ease;
          box-shadow: inset 0 0 8px rgba(255, 255, 255, 0.15);
        }
        .signup-form input::placeholder {
          color: #ddd;
          font-style: italic;
        }
        .signup-form input:focus {
          border-color: #ff4b87;
          background: rgba(255, 75, 135, 0.15);
          box-shadow: 0 0 12px rgba(255, 75, 135, 0.8);
        }

        .btn-group {
          display: flex;
          gap: 16px;
          margin-top: 15px;
        }

        .signup-btn {
          flex: 1;
          background: linear-gradient(90deg, #ff4b87, #ff0057);
          color: white;
          border: none;
          padding: 16px 0;
          font-size: 1.15rem;
          font-weight: 700;
          border-radius: 12px;
          cursor: pointer;
          box-shadow: 0 6px 15px rgba(255, 75, 135, 0.6);
          transition: background 0.3s ease, box-shadow 0.3s ease;
          user-select: none;
          text-transform: uppercase;
          letter-spacing: 1.2px;
        }
        .signup-btn:hover {
          background: linear-gradient(90deg, #ff1f6e, #e60048);
          box-shadow: 0 10px 25px rgba(230, 0, 72, 0.9);
        }
        .signup-btn:active {
          transform: scale(0.97);
        }

        .signup-btn.secondary {
          background: transparent;
          color: #ff4b87;
          border: 2.5px solid #ff4b87;
          box-shadow: none;
          text-transform: none;
          font-weight: 600;
        }
        .signup-btn.secondary:hover {
          background: #ff4b87;
          color: #fff;
          box-shadow: 0 8px 20px rgba(255, 75, 135, 0.5);
        }
      `}</style>
    </>
  );
};

export default DoctorSignup;
